import { useEffect } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";

// Constants
import { TITLE, SUB_TITLE} from "./AppDeveloperSpecializationConstants";


// Images
import apps from '../../../assets/img/partnerPortal/appDeveloper/apps.png';
import securityAnalytics from '../../../assets/img/partnerPortal/appDeveloper/security analytics.png';
import scalability from '../../../assets/img/partnerPortal/appDeveloper/scalability.png';
import lightBulbWithGear from '../../../assets/img/partnerPortal/appDeveloper/light-bulb-with-gear.png';
import collaboration from '../../../assets/img/partnerPortal/appDeveloper/cross-team-collaboration.png';
import grail from '../../../assets/img/partnerPortal/appDeveloper/grail.png';
import appDeveloperBackground from '../../../assets/img/partnerPortal/appDeveloper/fullWaveApp.png';
import checkmark from '../../../assets/img/partnerPortal/welcomeAccenture/checkmark-small.svg';
import checkmarWhite from '../../../assets/img/partnerPortal/appDeveloper/checkmark-white.svg';
import developerPortal from '../../../assets/img/partnerPortal/appDeveloper/developerPortal.png';
import developerForum from '../../../assets/img/partnerPortal/appDeveloper/developerForum.png';
import serviceEndorsement from '../../../assets/img/partnerPortal/appDeveloper/serviceEndorsement.png';

// Scss
import '../../../assets/css/partnerPortal/appDeveloper.scss';
import '../../../assets/css/partnerPortal/sales.scss';
import '../../../assets/css/partnerPortal/welcome.scss';


import Image from "react-bootstrap/Image";
import ButtonArrow from "../../../components/ButtonArrow";
import TitleSubTitleCenter from "../../../components/TitleSubTitleCenter";

function AppDeveloperSpecialization() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

  return (
    <>
        <div className="mb-3">
            <BannerOne bannerImage={appDeveloperBackground} title={TITLE} hasNoButton={true} subTitle={SUB_TITLE}  />
            <div className="containerAll">
                <TitleSubTitleCenter title={"Tailor and extend Dynatrace to the business needs of your customers"} subTitle={"Leverage the goldmine of contextual data in Dynatrace to create customer-specific"+ 
                    "and unique solutions. Create custom apps that leverage insights from your customer’s observability, " + 
                    " security, and business data to solve industry specific problems."} />
                <div className="productSection w-100 mt-4 mb-5">
                    <div className="productImage" >
                        <Image src={apps}  width={"100%"} />
                    </div>
                    <div className="productCheckPoint">
                        <div className="productItem mb-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                                <b>Dynatrace apps are the foundation for<br></br> delivering custom- 
                                and industry-specific use<br></br> cases</b> not supported by Dynatrace out-of-the-box.
                            </div>
                        </div>
                        <div className="productItem mb-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                                <b>Apps are fully integrated into Dynatrace</b><br></br> thanks to our new Strato design 
                                system that<br></br> addresses all the personalization, customization,<br></br> and collaboration needs.
                            </div>
                        </div>
                        <div className="productItem mb-3">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                                <b>Weave Dynatrace into your customers’ IT<br></br> fabric</b> by
                                 building custom solutions on top of<br></br> AppEngine.
                            </div>
                        </div>
                        <div className="productItem">
                            <img src={checkmark} />
                            <div className="contactGeneral fontWeight400 fontSize18">
                                <b>Integrate with your customers’ existing<br></br> ecosystem</b> and interact with 
                                cloud and on-<br></br>premises resources in an enterprise compliant and<br></br> secure way.
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className="w-100 mt-5 d-flex align-items-center flex-column">
                    <div className="introframeHeader w-100">
                            Why build on Dynatrace?
                    </div>
                    <div className="d-flex align-items-start w-100">
                        <div className="cardCol mt-5">
                            <img src={securityAnalytics} alt='...'  />
                            <div className="cardColText">Powers all custom use cases</div>
                            <div className="cardColSubText">Easiest and most secure platform for answer-driven automation and security use cases</div>
                        </div>
                        <div className="cardCol mt-5">
                            <img src={scalability} alt='...'  />
                            <div className="cardColText">Secure auto-scaling serverless app runtime</div>
                            <div className="cardColSubText">SSO, IAM, high-availability, security, managed secrets, golden path, low-code</div>
                        </div>
                        <div className="cardCol mt-5">
                            <img src={lightBulbWithGear} alt='...'  />
                            <div className="cardColText">Bring logic to data</div>
                            <div className="cardColSubText">Eliminates dataflow and privacy challenges due to encapsulated data, analytics powered by Dynatrace Grail® and automation capabilities powered by AutomationEngine®</div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center w-100 justify-content-center">
                        <div className="cardCol mt-5">
                            <img src={collaboration} alt='...'  />
                            <div className="cardColText">Break up silos</div>
                            <div className="cardColSubText">Provide collaboration across different teams, user groups and personas</div>
                        </div>
                        <div className="cardCol mt-5">
                            <img src={grail} alt='...'  />
                            <div className="cardColText">Business-specific</div>
                            <div className="cardColSubText">Combine data stored within Grail with external data and make this actionable</div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="d-flex flex-column align-items-start mt-5 margin96Botton">
                <div className="d-flex flex-column align-items-center waveImage w-100">
                    <div className="displayFlex align-items-center justify-content-center width67 m-auto ">
                        <div className="d-flex flex-column align-items-center justify-content-center width40 ">
                            <div className="d-flex align-items-start " >
                                <div className="textStyle">What’s in it for you?</div>
                            </div> 
                        </div>
                        <div className="d-flex flex-column align-items-center justify-content-center width55 ">
                            <div className="productItem mb-4">
                                <img src={checkmarWhite} />
                                <div className="subTextStyle">
                                    Differentiate and specialize with unique offerings on top of Dynatrace
                                </div>
                            </div>
                            <div className="productItem mb-4">
                                <img src={checkmarWhite} />
                                <div className="subTextStyle">
                                    Create customization service revenue
                                </div>
                            </div>
                            <div className="productItem mb-3">
                                <img src={checkmarWhite} />
                                <div className="subTextStyle">
                                    Provide answers and deliver better business outcomes on top of Dynatrace
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex flex-column align-items-start margin96Botton ">
                <div className="d-flex flex-column align-items-center justify-content-center bannerAppDeveloper width67 m-auto">
                    <div className="d-flex flex-column align-items-center width63">
                        <div className="d-flex align-items-stretch mb-4">
                            <div className="textStyle">AppDeveloper Specialization</div>
                        </div>
                        <div className="d-flex align-items-center align-self-stretch mb-3 ">
                            <div className="subTextBannerStyle">
                            We’ve extended the Partner Services 
                            Endorsement Program with the AppDeveloper Specialization. Individual partner employees can earn their 
                            AppDeveloper Specialization by taking the exam available on Dynatrace University. Partner organizations that 
                            are <b>Observability Services Endorsed</b>, which means they need to have <b>four Observability Services Certified individuals and two AppDeveloper Services Specialized individuals</b>, can apply to be 
                            AppDeveloper Services Endorsed in a given Geo.

                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center align-self-stretch ">
                            <a href={"https://university.dynatrace.com/certification/40373"} target="_blank" className="w-100 d-flex justify-content-center"  >
                                <div className="d-flex align-items-center justify-content-center width39 buttonBackground">
                                    <div className="buttonLettersStyle buttonBlack">Get started</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex flex-column align-items-center width67 mx-auto ">
                <div className="d-flex flex-column align-items-center width63 mb-5  ">
                    <div className="d-flex align-items-center align-self-stretch textStyle colorBlack m-auto">Resources</div>
                </div>
                <div className="align-items-start displayFlex">
                    <div className="d-flex flex-column align-items-center cardBackground width31 mr-4 ml-3">
                        <img src={developerPortal} width={"100%"} />
                        <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                            <div className="d-flex flex-column align-items-center align-self-stretch mb-4">
                                <div className="d-flex align-items-start align-self-stretch cardTitleApp mb-2">Developer Portal</div>
                                <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">Visit our Developer 
                                    Portal and check out our Sample Apps.
                                </div>
                            </div>
                            <ButtonArrow link={"https://developer.dynatrace.com/"} buttonName={"Learn More"} width="15%" />

                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-center cardBackground width31 mr-4 ">
                        <img src={developerForum} width={"100%"} />
                        <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                            <div className="d-flex flex-column align-items-center align-self-stretch">
                                <div className="d-flex align-items-start align-self-stretch cardTitleApp mb-2">Developer Forum</div>
                                <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">
                                    Share knowledge, connect with others, and explore the best practices when creating apps on Dynatrace.
                                </div>
                            </div>
                            <ButtonArrow link={"https://dt-url.net/devforum"} buttonName={"Learn More"} width="15%" />

                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-center cardBackground width31 ">
                        <img src={serviceEndorsement} width={"100%"} />
                        <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                            <div className="d-flex flex-column align-items-center align-self-stretch">
                                <div className="d-flex align-items-start align-self-stretch  cardTitleApp mb-2">Service Endorsement<br></br> Program</div>
                                <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">
                                    Find out more about the program and how you can get involved.
                                </div>
                            </div>
                            <ButtonArrow link={"https://partners.dynatrace.com/#/page/service_endorsement_pro"} buttonName={"Learn More"} width="15%" />

                        </div>
                    </div>
                </div>
            </div>


        </div >
    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default AppDeveloperSpecialization;

